import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getTodayDate } from "utils/commonFunctions";
import { DateRangePicker, DateRange } from "mui-daterange-picker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import { BRAND } from "themes";
import { styles } from "../styles";

interface Props {
  dateRangeHandler: (range: DateRange) => void;
  dateApplyHandler: () => void;
  startDate: Date;
  endDate: Date;
}

const pickerTheme = createTheme({
  palette: {
    primary: {
      main: BRAND.primary,
      dark: BRAND.primaryDark,
      light: "#EDE9FE",
    },
  },
});

const CustomDialog: React.FC<Props> = (props) => {
  const { dateRangeHandler, dateApplyHandler, startDate, endDate } = props;
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = () => {
    handleClose();
    dateApplyHandler();
  };

  const dateToShowString = (start: string, end: string) => {
    const today = moment(new Date(moment().toDate())).format("DD-MM-YYYY");
    if (start === end && start === today) {
      return "Today";
    } else if (start === end) {
      return start;
    } else return `${start} - ${end}`;
  };
  const dateToShow = dateToShowString(
    moment(startDate).format("DD-MM-YYYY"),
    moment(endDate).format("DD-MM-YYYY")
  );

  return (
    <ThemeProvider theme={pickerTheme}>
      <div>
        <Button
          variant="outlined"
          sx={styles.dateButton}
          onClick={() => setOpen(true)}
          startIcon={<CalendarMonthOutlinedIcon />}
        >
          {dateToShow}
        </Button>

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: styles.dialogPaper }}
        >
          <DialogTitle sx={styles.dialogHeader}>
            <Typography sx={styles.dialogTitle}>Select date</Typography>
            <IconButton
              onClick={handleClose}
              aria-label="Close date picker"
              sx={styles.dialogClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={styles.dialogBody}>
            <DateRangePicker
              open={open}
              toggle={toggle}
              maxDate={getTodayDate()}
              onChange={(range) => dateRangeHandler(range)}
              definedRanges={[]}
              initialDateRange={{
                startDate,
                endDate,
              }}
            />
          </DialogContent>
          <DialogActions sx={styles.dialogFooter}>
            <Button onClick={handleClose} sx={styles.cancelButton}>
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={styles.applyButton}
            >
              Apply
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default CustomDialog;
